"use client"
import { useContext, useEffect, useState } from "react"
import Accordion from "../shared/accordion/Accordion"
import AccordionCard from "./AccordionCard"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"

const AccordionSection = ({ data, gapValue, gapValueMobile, insideAmenitiesDetailsPage, customAccordionClasses, optimizedImage }: any) => {

	const [activeAccordion, setActiveAccordion] = useState(2)
	const { isIpad, isMobile } = useContext(screenSizeContext)
	useEffect(() => { setActiveAccordion(data?.length - 1) }, [data])

	return (
		<div>
			{data?.slice(0,5).map(
				(item: any, index: number) =>
					<Accordion
						key={index}
						activeAccordion={activeAccordion}
						setActiveAccordion={setActiveAccordion}
						index={index}
						action={() => { }}
						gapValue={gapValue}
						gapValueMobile={gapValueMobile}
						className={`h-[78.4rem] lg:h-[48.8rem] ${customAccordionClasses}`}
					>
						{insideAmenitiesDetailsPage ?
							<AccordionCard
								index={index}
								activeAccordion={activeAccordion}
								data={{ ...item, bg: index == 0 ? "bg-oSilver-100" : index == 1 ? "bg-oSilver-90" : index == 2 ? "bg-oSilver-80" : index == 3 ? "bg-oSilver-70" : "bg-oSilver-60" }}
								hasSwiper
								SwiperMedia={item?.media?.map((item: any) => ({
									url: `${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${item?.media_name}`,
									type: item?.media_type,
								}))}
								cardTitle= {item?.title?.en}	
								insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
								optimizedImage={optimizedImage}
							/>

							: (
								<AccordionCard
									index={index}
									activeAccordion={activeAccordion}
									data={{ ...item[0], bg: index == 0 ? "bg-oSilver-100" : index == 1 ? "bg-oSilver-80" : "bg-oSilver-60" }}
									optimizedImage={optimizedImage}
								/>
							)

						}

					</Accordion>
			)}
		</div>
	)
}

export default AccordionSection
